import { AlertCircle } from 'lucide-react';

/** Inline upload error banner (red alert box, larger h-5 icon variant).
 *
 * Extracted verbatim from the bulk-upload modals (BulkUploadModal /
 * TargetBulkUploadModal), where this exact markup was duplicated. Note the icon
 * is h-5 w-5 here (vs FormErrorBanner's h-4 w-4) — the two are intentionally
 * distinct so each call site keeps its original rendered DOM. Callers keep their
 * own `{error && (...)}` guard and pass the message string in. */
export function UploadErrorBanner({ message }: { message: string }) {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-3">
      <AlertCircle className="h-5 w-5 flex-shrink-0 text-red-500 mt-0.5" />
      <p className="text-sm text-red-600">{message}</p>
    </div>
  );
}
